/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import accordion from '../accordion/locale';
import breadcrumbs from '../breadcrumbs/locale';
import datepicker from '../datepicker/locale';
import datatable from '../data-table/locale';
import buttongroup from '../button-group/locale';
import fileuploader from '../file-uploader/locale';
import menu from '../menu/locale';
import modal from '../modal/locale';
import drawer from '../drawer/locale';
import pagination from '../pagination/locale';
import select from '../select/locale';
import toast from '../toast/locale';
var en_US = {
  accordion: accordion,
  breadcrumbs: breadcrumbs,
  datepicker: datepicker,
  datatable: datatable,
  buttongroup: buttongroup,
  fileuploader: fileuploader,
  menu: menu,
  modal: modal,
  drawer: drawer,
  pagination: pagination,
  select: select,
  toast: toast
};
export default en_US;